import { curry } from 'lodash';

import fuzzyscore from '../fuzzyscore';

import { NAME } from './constants';

const queryScore = curry((query: string, service: { name: string }) => {
  return -fuzzyscore(query, service[NAME]);
});

export default queryScore;
